export const PageFeatureFlags = {
  AccountsAccountBuilderQuizEntryPointEnabled: 'accounts.enable-account-builder-quiz-entry-point',
  CoverSMSAppRegEnabled: 'cover.enable-sms-app-reg',
  ShowCanadaPostBanner: 'show-canada-post-banner',
  CreditPassCreditIntentToReg: 'credit.pass-credit-intent-to-registration',
} as const;
